module.exports = __webpack_public_path__ + "static/media/total_darkblue.6bd706f3.svg";